import URL from '../constant/URL';
import httpAxios from '../http/httpAxios';

const STAR_HEADERS = {
  "Customer-Number": null,
  "Content-Type": 'application/json',
  "Accept": 'application/json',
  "Service-Name": 'aibarosem',
  "Auth-Token": null,
  "Device-Name": null,
  "App-Package": null,
  "App-Version": null,
}

// 별보상 인증 API
export const starAuthAPI = async (data) => {
  const resp = await httpAxios({
    header: {
      "Contract-Number": data,
      ...STAR_HEADERS
    },
    isAuth: false,
    url: `${URL.API.STAR_SHOP.AUTH}`,
    method: 'POST',
    data: btoa(`{"Contract-Number":${data}}`)
  });
  if (resp && resp.status === 201) {
    await localStorage.setItem("access.starToken", resp.data.RESP_RESULT.TOKEN);
    return { status: resp.status }
  } else {
    return {
      url: `${URL.API.STAR_SHOP.AUTH}`,
      status: resp?.status,
      res: resp?.data,
      req: JSON.stringify(resp?.config?.headers),
    }
  }
  

}

// 보상 적립 내역 카운트
export const starShopHistoryCntAPI = async (data) => {
  const {
    CONSTRACT_NUMBER,
    CUSTOMER_NUMBER,
    SERVICE_CD
  } = data;
  const startToken = localStorage.getItem("access.starToken");
  const url = `${URL.API.STAR_SHOP.I}/historyCnt/contracts/${CONSTRACT_NUMBER}/members/${CUSTOMER_NUMBER}/services/${SERVICE_CD}`;

  if (!startToken) return;
  const resp = await httpAxios({
    header: {
      ...STAR_HEADERS,
      "Contract-Number": data.CONSTRACT_NUMBER,
      "Auth-Token": startToken,
    },
    isAuth: false,
    url
  });

  if (resp && resp.status === 200) {
    
    const { RESP_RESULT } = resp.data;
    return {
      status: resp.status,
      total: JSON.parse(RESP_RESULT.result)
    }
  } else {
    return {
      status: resp?.status,
      res: resp?.data,
      req: JSON.stringify(resp?.config?.headers),
      url
    }
  }
}

// 보상 적입 내역 
export const starShopHistoryAPI = async (data, params) => {
  const {
    CONSTRACT_NUMBER,
    CUSTOMER_NUMBER,
    SERVICE_CD,
  } = data;

  const startToken = localStorage.getItem("access.starToken");
  if (!startToken) return;
  const url = `${URL.API.STAR_SHOP.I}/history/${SERVICE_CD}/contracts/${CONSTRACT_NUMBER}/members/${CUSTOMER_NUMBER}`;
  const resp = await httpAxios({
    header: {
      ...STAR_HEADERS,
      "Contract-Number": data.CONSTRACT_NUMBER,
      "Auth-Token": startToken,
    },
    url,
    isAuth: false,
    params
  });

  if (resp && resp.status === 200) {
    const { RESP_RESULT } = resp.data;
    return {
      status: resp?.status,
      result: JSON.parse(RESP_RESULT.result),
    }
  } else {
    return {
      url,
      param1: params,
      status: resp?.status,
      res: resp?.data,
      req: JSON.stringify(resp?.config?.headers),
    }
  }

}

// 보상 적입
export const starSaveUpAPI = async (data, params) => {
  const {
    CONSTRACT_NUMBER,
    CUSTOMER_NUMBER,
    SERVICE_CD,
    REWARD_AUTH_CD,
  } = data;
  const startToken = localStorage.getItem("access.starToken");

  if (!startToken) return;
  const url = `${URL.API.STAR_SHOP.V3}/addPoint/services/${SERVICE_CD}/rewardTypes/STUDY/rewardCodes/COMP/members/${CUSTOMER_NUMBER}?REWARD_AUTH_CD=${REWARD_AUTH_CD}`;
  const resp = await httpAxios({
    header: {
      ...STAR_HEADERS,
      "Contract-Number": CONSTRACT_NUMBER,
      "Customer-Number": CUSTOMER_NUMBER,
      "Auth-Token": startToken,
    },
    isAuth: false,
    method: "post",
    data: params,
    url
  });

  if (resp && resp.status === 200) {
    const { RESP_RESULT } = resp.data;
    return {
      status: resp?.status,
      result: RESP_RESULT.SUCCESS_YN
    }
  } else {
    return {
      url,
      param1: params,
      status: resp?.status,
      res: resp?.data,
      req: JSON.stringify(resp?.config?.headers),
    }
  }
}